module.exports = __webpack_public_path__ + "school/img/practice_history_topic_guide_bg.83bd78a0.jpg";